import React from "react";
function PrivacyPolicy(){
    return(
        <>
        <section className="breadcrumb-main pb-15 pt-15 bookingHeaderSection" >
            <div className="section-shape section-shape1 top-inherit bottom-0" ></div>
            <div className="breadcrumb-outer">
                <div className="container">
                    <div className="breadcrumb-content text-center">
                        <h1 className="mb-3">Privacy Policy</h1>
                    </div>
                </div>
            </div>
        </section>
        <section className="trending pt-6 pb-0 bg-lgrey">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12 col-xs-12 mb-4">

                        <h3>1. Information We Collect</h3>
                        <p>We collect different types of information in order to provide you with a seamless and personalized experience. The types of information we may collect include:</p>
                        <h5>Personal Information:</h5>
                        <p>When you make a booking, subscribe to our newsletter, or contact us for assistance, we may collect personal details such as:</p>
                        <ul className="list">
                            <li>Name</li>
                            <li>Address</li>
                            <li>Email address</li>
                            <li>Phone number</li>
                            <li>Payment information (such as credit card details)</li>
                            <li>Passport or travel document details (for booking purposes)</li>
                        </ul>
                        <h5>Usage Data:</h5>
                        <p>We may also collect non-personally identifiable information automatically when you use our website, including:</p>
                        <ul className="list" >
                            <li>IP address</li>
                            <li>Browser type and version</li>
                            <li>Pages visited on the website</li>
                            <li>Time spent on the site</li>
                            <li>Referring website (if applicable)</li>
                            <li>Device information</li>
                        </ul>
                        <h5>Cookies and Tracking Technologies:</h5>
                        <p>We use cookies and similar tracking technologies to improve your experience on our website. These technologies help us analyze trends, track users’ movements, and gather demographic information. You can control cookie settings through your browser, but disabling cookies may affect your experience on our website.</p>

                        <h3>2. How We Use Your Information</h3>
                        <p>We use the information we collect for several purposes, including:</p>
                        <ul className="list" >
                            <li>Processing Bookings: To complete and manage your travel bookings, including hotel reservations, flights, tours, and car hire.</li>
                            <li>Customer Support: To respond to your inquiries, assist with travel planning, and provide customer support.</li>
                            <li>Marketing: To send you promotional offers, updates, and newsletters if you’ve opted in. You can unsubscribe at any time.</li>
                            <li>Improvement of Services: To enhance our website, services, and user experience based on feedback and usage data.</li>
                            <li>Compliance and Legal Requirements: To comply with legal obligations, resolve disputes, and enforce our terms and conditions.</li>
                        </ul>

                        <h3>3. How We Protect Your Information</h3>
                        <p>We take data security seriously and use industry-standard practices to protect your personal information from unauthorized access, alteration, or disclosure. These include:</p>
                        <ul className="list" >
                            <li>Encryption: We use secure SSL encryption to protect sensitive information during transmission.</li>
                            <li>Access Controls: We limit access to your personal data to only those employees who need it to perform their duties.</li>
                            <li>Secure Payment Processing: Payment details are handled by secure payment processors, and we do not store your full credit card details.</li>
                        </ul>
                        <p>While we use the latest security technologies, please be aware that no method of transmission over the Internet or electronic storage is 100% secure.</p>

                        <h3>4. Sharing Your Information</h3>
                        <p>We do not sell, rent, or trade your personal information to third parties. However, we may share your information in the following circumstances:</p>
                        <ul className="list" >
                            <li><strong>Service Providers:</strong> We may share your information with trusted third parties (e.g., airlines, hotel chains, tour operators) who assist us in providing travel-related services and processing bookings.</li>
                            <li><strong>Legal Requirements:</strong> We may disclose your information if required by law, to protect our legal rights, or in response to legal proceedings (e.g., a court order or subpoena).</li>
                            <li><strong>Business Transfers:</strong> In the event of a merger, acquisition, or sale of our business, your information may be transferred as part of the transaction.</li>
                        </ul>

                        <h3>5. Your Rights and Choices</h3>
                        <p>You have several rights regarding your personal information, including:</p>
                        <ul className="list" >
                            <li><strong>Access:</strong> You can request a copy of the personal information we hold about you.</li>
                            <li><strong>Correction:</strong> You can correct or update any inaccurate or incomplete information.</li>
                            <li><strong>Deletion:</strong> You can request the deletion of your personal information, subject to certain legal restrictions.</li>
                            <li><strong>Opt-Out:</strong> You can opt out of receiving promotional emails and newsletters by clicking "unsubscribe" in the email or contacting us directly.</li>
                            <li><strong>Cookie Preferences:</strong> You can manage cookie settings through your browser settings to accept or block cookies.</li>
                        </ul>

                        <h3>8. Changes to This Privacy Policy</h3>
                        <p>We reserve the right to update or modify this Privacy Policy at any time. Any changes will be posted on this page with an updated "Effective Date." Please check this page periodically for updates. Your continued use of our website after any changes indicates your acceptance of the new Privacy Policy.</p>

                        <h3>9. Contact Us</h3>
                        <p>If you have any questions or concerns about this Privacy Policy or the way we handle your personal information, please feel free to contact us:</p>
                        <p><strong>The Holiday Experts</strong></p>
                        <p>
                            Email: [Insert Email Address]<br />
                            Phone: [Insert Phone Number]<br />
                            Postal Address: [Insert Address]
                        </p>

                    </div>
                </div>
            </div>
        </section>         
        </>
    )
}
export default PrivacyPolicy;